import React, { Fragment } from "react";
import './banner.scss';
import img from '../../../media/banner-home.png';

const Banner = () => {

return (
    <Fragment>
        <div className="Banner text-center">
            <img className="banner-home max-width-1440" src={img} alt="Club La Voz" />
        </div>
    </Fragment>
)
}

export default Banner;